import React from 'react';

const cardData = [
  {
    icon: 'bi bi-house-door',
    title: 'Residential Duct Cleaning',
    desc: 'Comprehensive duct cleaning for homes by removing dust, allergens and debris which thereby improves indoor air quality and HVAC efficiency.',
  },
  {
    icon: 'bi bi-building',
    title: 'Commercial Duct Cleaning',
    desc: 'Professional duct cleaning for offices, retail and commercial buildings. Regular maintenance to keep your workplace healthier.',
  },
  {
    icon: 'bi bi-droplet',
    title: 'Dryer Vent Cleaning',
    desc: 'Reduce fire risk and improve dryer performance with professional dryer vent cleaning. We clear lint buildup and blockages safely.',
  },
  {
    icon: 'bi bi-cloud-haze',
    title: 'Deodorization and Sanitization',
    desc: 'Professional fogging treatment that helps eliminate bacteria, mold, and odor which grows inside your duct system for cleaner and fresher air.',
  },
  {
    icon: 'bi bi-thermometer-sun',
    title: 'Furnace and Vent Cleaning',
    desc: 'Thorough cleaning of components and vents to remove dust buildup, and help your heating system operate more efficiently.',
  },
];

function OneStop() {
  return (
    <>
      {cardData.map((item, ind) => (
        <div className="col-xl-4 col-md-6 m-b60" key={ind}>
          <div className="icon-bx-wraper style-3 text-center">
            <div className="icon-content">
              <div className="icon-media m-b20">
                <i className={item.icon} style={{ fontSize: '2.5rem', color: 'white' }}></i>
              </div>
              <h4 className="title">{item.title}</h4>
              <p className="m-b0">{item.desc}</p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default OneStop;
